import React, {Component} from 'react';
import {withRouter } from 'react-router-dom';
import  MUIDataTable  from 'mui-datatables';
import axiosInstance from '../../../axiosInstance';
import { logOut } from '../../helper';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { format,startOfMonth } from 'date-fns'


const ticket_log_table_columns = [
    {
        "name" : "ticket_id",
        "label" : "დავალების id",
        "options": {
            "sort" : true
        }
    },
    {
        "name" : "action",
        "label" : "მოქმედება",
        "options": {
            "sort" : true
        }
    },
    {
        "name" : "updated_column",
        "label" : "განახლებული ველი",
        "options": {
            "sort" : true
        }
    },
    {
        "name" : "old_value",
        "label" : "ძველი",
        "options": {
            "sort" : true
        }
    },
    {
        "name" : "new_value",
        "label" : "ახალი",
        "options": {
            "sort" : true
        }
    },
    {
        "name" : "created_at",
        "label" : "თარიღი",
        "options": {
            "sort" : true
        }
    },
    
]

const activity_columns = [
    {
        "name" : "type",
        "label" : "ტიპი",
        "options": {
            "sort" : false,
            customBodyRender:  function(value){
                return value ? value : 0;
            }
        }
    },
    {
        "name" : "closed_successfully",
        "label" : "წარმატებული",
        "options": {
            "sort" : false,
            customBodyRender:  function(value){
                return value ? value : 0;
            }
        }
    },
    {
        "name" : "closed_unsuccessfully",
        "label" : "წარუმატებელი",
        "value": 0,
        "options": {
            "sort" : false,
            customBodyRender:  function(value){
                return value ? value : 0;
            }
        }
    },
    {
        "name" : "pending",
        "label" : "მიმდინარე",
        "options": {
            "sort" : false,
            customBodyRender:  function(value){
                return value ? value : 0;
            }
        }
    },
]
const activity_options = {
    filterType: 'checkbox',
    selectableRowsHeader:false,
    expandableRowsHeader:false,
    viewColumns:true,
    print:false,
    filter:true,
    selectableRows:'none',
    search:false,
    download:false,
    pagination:true
}

class Profile extends Component{
    constructor(props){
        super(props);
        this.state= {
            ticket_logs : [],
            date_from:format(startOfMonth(new Date()),'yyyy-MM-dd'),
            date_to:format(new Date(), 'yyyy-MM-dd'),
            activity_data:[],
            is_logged_user:false,
            password:{
                current_password:"",
                new_password:"",
                error_messages:{
                    current_password_message : "",
                    new_password_message:"",
                },
                error:{
                    current_password : false,
                    new_password : false,
                },
                response :{
                    isValid : false,
                    isInValid : false,
                },
                response_message : ""
            },
            user:null,
            options:{
                filterType: 'checkbox',
                selectableRowsHeader:false,
                expandableRowsHeader:false,
                viewColumns:false,
                print:false,
                filter:false,
                selectableRows:'none',
            },
        }
    }
    componentDidMount(){
        this.fetch_profile();
    }




    fetch_profile(){
        this.fetch_user_profile();
        this.fetch_user_activity();
    }   
    componentDidUpdate(prevProps, prevState, snapshot){
        if(prevProps.match.params.id !== this.props.match.params.id){
            this.fetch_profile();
        }

        if(prevState.date_from !== this.state.date_from || prevState.date_to !== this.state.date_to){
            this.fetch_user_activity();
        }
    }
    fetch_user_profile(){
        let user_id = this.props.match.params.id
        axiosInstance.get('users/'+ user_id)
        .then(response=>{
            this.setState({
                is_logged_user: response.data.data.isAuth,
                user:response.data.data
            })
        })
        .catch(err => {
            if(err.response !== null){
                if(err.response.status === 401){
                    logOut(this.props);
                }
            }
        })
    }
    fetch_user_activity(){
        let user_id = this.props.match.params.id;
        let date_from = this.state.date_from;
        let date_to = this.state.date_to;
        axiosInstance.get('/users/'+user_id+'/activity',{
            params:{
                date_from:date_from,
                date_to:date_to
            }
        })
        .then(response=>{
            this.setState({
                activity_data:response.data.data
            })
        })
        .catch(err => {
            if(err.response !== null){
                if(err.response.status === 401){
                    logOut(this.props);
                }
            }
        })
    }

    on_fetch_user_activity(data){
        this.setState({
            activity_data:data
        })
    }


    on_fetch_ticket_logs(data){
        this.setState({
            ticket_logs:data
        })
    }
    startDateChanged(e){
        this.setState({
            date_from:e.target.value
        })
        
    }

    endDateChanged(e){
        this.setState({
            date_to:e.target.value
        })
    }

    onChangeCurrentPassword(event){
       this.setState({
           password:{
               ...this.state.password,
               current_password:event.target.value,
               response :{
                isValid : false,
                isInValid : false,
            },
           }
       })
    }
    onChangeNewPassword(event){
        this.setState({
            password:{
                ...this.state.password,
                new_password:event.target.value,
                response :{
                    isValid : false,
                    isInValid : false,
                }
            }
        })
    }



    onChangePasswordBtnClick(){
        let user_id = this.props.match.params.id;
        axiosInstance.put('users/'+user_id+'/password',{
            current_password: this.state.password.current_password,
            new_password:this.state.password.new_password
        }).then(response => {
            this.setState({
                password:{
                    ...this.state.password,
                    response:{
                        ...this.state.password.response,
                        isValid:true
                    },
                    response_message:response.data.message
                }
            })
        }).catch(err => {
            this.setState({
                password:{
                    ...this.state.password,
                    response:{
                        ...this.state.password.response,
                        isInValid:true
                    },
                    response_message:err.response.data.message
                }
            })
        })
    }
    render(){
        return (
            <div  className = "content-main">
                <Form id="user-profile-info">
                    <Form.Group as={Row}>
                        <Form.Label column xs={6} > მომხმარებელი </Form.Label>
                        <Form.Label column xs={6} > {this.state.user?.username} </Form.Label> 
                    </Form.Group>
                    <Form.Group as={Row}>
                        <Form.Label column xs={6} > როლი </Form.Label>
                        <Form.Label column xs={6} > {this.state.user?.role.display_name} </Form.Label> 
                    </Form.Group>
                </Form>   
                {this.state.user?.role.id !== 1 && <div id="profile-activity-content">
                    <div className="filters">
                        <div className = "filter-column">
                                <label>საწყისი თარიღი</label>
                                <input type="date" 
                                className="form-control" 
                                onChange = {(e) => this.startDateChanged(e)}
                                value = {this.state.date_from}
                                />
                        </div>
                        <div className = "filter-column">
                            <label>საბოლოო თარიღი</label>
                            <input 
                                type="date" 
                                className="form-control" 
                                onChange = {(e) => this.endDateChanged(e)}
                                value = {this.state.date_to}
                            />
                        </div>
                    </div>
                    <MUIDataTable
                        title={"Activity"}
                        data={this.state.activity_data}
                        columns={activity_columns}
                        options = {activity_options}
                    />
                </div>}
                <Form id="profile-password-content" hidden={!this.state.is_logged_user}>
                    <Form.Row  >
                        <Form.Group as={Col} md="4" >
                            <Form.Label>პაროლის შეცვლა </Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="მიმდინარე პაროლი"
                                hidden = {true}
                                isInvalid = {Boolean(this.state.password.response.isInValid)}
                                isValid = {Boolean(this.state.password.response.isValid)}
                                onChange = {null}
                            />
                            <Form.Control.Feedback type="invalid" >
                              {this.state.password.response_message}
                            </Form.Control.Feedback>
                            <Form.Control.Feedback >
                                {this.state.password.response_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row >
                        <Form.Group as={Col} md="4" >
                            <Form.Control
                                name="status"
                                type="password"
                                placeholder="მიმდინარე პაროლი"
                                isInvalid = {this.state.password.error.current_password}
                                value = {this.state.password.current_password}
                                onChange = {(event)=>this.onChangeCurrentPassword(event)}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.password.error_messages.current_password_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="4" >
                            <Form.Control
                                type="password"
                                placeholder="ახალი პაროლი"
                                name="status"
                                isInvalid = {this.state.password.error.new_password}
                                value = {this.state.password.new_password}
                                onChange = {(event)=>this.onChangeNewPassword(event)}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.password.error_messages.new_password_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="4" >
                           <Button onClick = {(event)=>this.onChangePasswordBtnClick()} className="btn-secondary">შეცვლა</Button>
                        </Form.Group>
                    </Form.Row>
                </Form>
            </div>
        )
    }
}

export default withRouter(Profile)